import {Routes} from '@angular/router';
import {HomeComponent} from "./home/home.component";
import {LoginComponent} from "./login/login.component";
import {AssetOverviewComponent} from "./assets/asset-overview/asset-overview.component";
import {CollectionOverviewComponent} from "./collection/collection-overview/collection-overview.component";
import {CollectionViewComponent} from "./collection/collection-view/collection-view.component";
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {
    CollectionReadonlyViewComponent
} from "./collection/collection-readonly-view/collection-readonly-view.component";
import {IntegratedComponent} from "./integrated/integrated.component";
import {FeedbackComponent} from "./home/feedback/feedback.component";
import {ErrorPagesComponent} from "./error-pages/error-pages.component";
import {UserAdminComponent} from "./user-admin/user-admin.component";

export const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'feedback', component: FeedbackComponent},
    {path: 'login', component: LoginComponent},
    {path: 'reset-password', component: ResetPasswordComponent},
    {path: 'assets', component: AssetOverviewComponent},
    {path: 'assets:uuid', component: AssetOverviewComponent},
    {path: 'collections', component: CollectionOverviewComponent},
    {path: 'collections/:id', component: CollectionViewComponent},
    {path: 'collections/shared/:key', component: CollectionReadonlyViewComponent},
    {path: 'collections/public/:slug', component: CollectionReadonlyViewComponent},
    {path: 'collections/:id/:title', component: CollectionViewComponent},
    {path: 'user-admin', component: UserAdminComponent},
    {path: 'integrated', component: IntegratedComponent},
    {path: 'Account/dashboard', redirectTo: '/', pathMatch: 'full'},
    {path: 'shared/:id', component: ErrorPagesComponent,
         data: {errorType: 'shared'}},
    {path: 'transfer/:id', component: ErrorPagesComponent,
        data: {errorType: 'transfer'}},
    {path: '**', component: ErrorPagesComponent,
        data: {errorType: 'generic'}},

];
